import { render, staticRenderFns } from "./NewsCategoryListPage.vue?vue&type=template&id=7978c43e&"
import script from "./NewsCategoryListPage.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports